import { render, staticRenderFns } from "./BriefData.vue?vue&type=template&id=841686be&scoped=true&"
import script from "./BriefData.vue?vue&type=script&lang=js&"
export * from "./BriefData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "841686be",
  null
  
)

export default component.exports